import { inputClass } from "@/components/ui";
import { useI18n } from "./LocaleProvider";
import { LOCALES, LOCALE_NAMES, isLocale } from "./locales";

/**
 * Where somebody changes the language they read Kontora in (K-36).
 *
 * Each language is listed **in itself** — "Deutsch", not "German" — because
 * somebody looking for their own language is looking for a word they recognise,
 * and translating the list into a language they cannot read defeats the purpose.
 *
 * The choice is stored against the person rather than the household. A German
 * household with one English-reading member is an ordinary thing, and their
 * screen is the only one that moves.
 */
export function LanguagePicker() {
  const { locale, setLocale, changing, t } = useI18n();

  return (
    <label className="block">
      <span className="block text-sm font-medium text-ink">{t("app.language")}</span>
      <select
        value={locale}
        disabled={changing}
        onChange={(event) => {
          if (isLocale(event.target.value)) setLocale(event.target.value);
        }}
        data-testid="language-picker"
        className={`${inputClass} min-h-11`}
      >
        {LOCALES.map((option) => (
          <option key={option} value={option}>
            {LOCALE_NAMES[option]}
          </option>
        ))}
      </select>
    </label>
  );
}
